/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2024-07-04 10:32:03
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-12-24 16:35:04
 * @FilePath: \qcloud-web-pc-4.0\src\components\page-header\work-space\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import "./index.scss";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "@/redux/hooks";
import { setLanguage } from "@/utils/utils";

const WorkSpace = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const loginStatus = useAppSelector((state) => state.user.loginStatus);
  const userInfo = useAppSelector((state) => state.user.userInfo);
  const { language } = useAppSelector((state) => state.common);
  const isZh = language === "zh";
  const { t } = useTranslation("header");

  let url = `/${language}/l/login`;
  const { pathname } = location;
  if (
    pathname.includes("/computerServices/quantumVm") ||
    pathname.includes("/education/courseDetails") ||
    pathname.includes("/education/financeIndex")
  ) {
    url = `/${language}/l/login?forward=${pathname}`;
  }
  const getWorkBenchUrl = () => {
    return process.env.REACT_APP_WORKBENCH_URL || "https://console.originqc.com.cn/";
  };

  const handleSwitchEn = () => {
    setLanguage("en");
    // console.log(location, 'location');
    // if (location.pathname.includes('wxLogin')) {
    //   navigate(`/${language}/l/login`);
    // }
  };

  return (
    <div className="work-space">
      {/* <a
        className='link-button work-bench-link'
        rel='noreferrer'
        href={`${getWorkBenchUrl()}${language}/computerServices/${loginStatus ? 'dashboard': 'services'}` }
      >
        {t('workbench')}
      </a> */}
      {/* <span className="logo-text" onClick={handleGoHome}>
        {t("home")}
      </span>
      <a
        className="logo-text"
        href={`${process.env.REACT_APP_API_URL}${language}/documentCenter`}
      >
        {t("documentShow")}
      </a> */}
      <div className="lang">
        <span
          className={`${isZh ? "active" : ""} lang-item`}
          onClick={() => setLanguage("zh")}
        >
          中
        </span>
        <span className="divided-line">|</span>
        <span
          className={`${!isZh ? "active" : ""} lang-item`}
          onClick={() => handleSwitchEn()}
        >
          EN
        </span>
      </div>
    </div>
  );
};
export default WorkSpace;